import { useState } from 'react'
import FounderLayout, { type FounderSection } from './FounderLayout'
import FounderHome from './FounderHome'
import FounderTeam from './FounderTeam'
import {
  ClientsView, PipelineView, InvoicesView, ExpensesView,
  CampaignsView, AdPerformanceView, BudgetView, ProjectsView,
  ContentCalendarView, SchedulingView, FounderTasksView,
} from './FounderModuleViews'

// ─────────────────────────────────────────────────────────────
// FounderDashboard — root page for all 3 founders.
// FounderLayout applies the permission-filtered sidebar;
// the section state drives which content panel renders.
// ─────────────────────────────────────────────────────────────

function SectionContent({ section, onNav }: { section: FounderSection; onNav: (s: FounderSection) => void }) {
  switch (section) {
    case 'home':             return <FounderHome onNav={onNav} />
    case 'team':             return <FounderTeam />
    case 'tasks':            return <FounderTasksView />
    case 'clients':          return <ClientsView />
    case 'pipeline':         return <PipelineView />
    case 'invoices':         return <InvoicesView />
    case 'expenses':         return <ExpensesView />
    case 'campaigns':        return <CampaignsView />
    case 'ad-performance':   return <AdPerformanceView />
    case 'budget':           return <BudgetView />
    case 'projects':         return <ProjectsView />
    case 'content-calendar': return <ContentCalendarView />
    case 'scheduling':       return <SchedulingView />
    default:                 return <FounderHome onNav={onNav} />
  }
}

export default function FounderDashboard() {
  const [activeSection, setActiveSection] = useState<FounderSection>('home')

  const handleNav = (section: FounderSection) => {
    setActiveSection(section)
    // Scroll to top whenever we change sections (useful on mobile)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <FounderLayout active={activeSection} onNav={handleNav}>
      <SectionContent section={activeSection} onNav={handleNav} />
    </FounderLayout>
  )
}
